export default (eventType, path) => {
  return {
    event: eventType, // Dinamic Data
    sectionName: path, // Dynamic Data
  };
};
